export const language: any = {
  main: "メイン",
  ingredients: "材料",
  ai_chef: "AIシェフ",
  favorites: "お気に入り",
  menu: "メニュー",
  get_start: "始める",
  title_first_1: "年齢に応じたレシピをAIが提案",
  title_second_1: "メニューからレシピまで完璧に整理",
  content_1: "毎日のメニューやカロリーを心配する必要はありません。これからはHey Cookerにお任せください！",
  title_first_2: "今日は肌寒いですね、お疲れ様です。",
  title_second_2: "仕事帰りにブデチゲはどうですか？",
  content_2: "冷蔵庫に残っている缶詰やインスタントラーメンを使って、簡単な夕食を作りましょう！",
  my_food_ingredients: "何を料理するか迷っていますか？",
  btn_add_photo: "画像を選ぶか写真を撮る",
  my_food_reason: "手元にある材料を選んでください",
  btn_get_cooking: "AI料理提案を受け取る",
  enriching_title: "体と心を豊かにする",
  enriching: "レシピ集",
  photo_registration_title: "写真やレシートを撮影して<br/>メニューのおすすめを受け取りましょう！",
  photo_registration_content: `AIで材料を識別し、レシピを分析して<br/>料理の楽しさを増やしましょう！`,
  food_suggestions_title: "何を食べるべきか悩んでいますか？",
  food_suggestions_sub_title: "テーマ別の料理",
  our_interests_title: "自分や家族にぴったりのメニューを作りましょう！",
  our_interests_sub_title: "年齢や性別に応じて選んでください。",
  favorite_title: "多様な料理ノート",
  weather_title: "肌寒い天気に合う料理",
  video_title: "臨場感のある動画で確認",
  tag: {
    close: "閉じる",
    open: "開く"
  },
  no_data: "データがありません",
  update_version_submit: "今すぐ更新",
  update_version_title: "新しいバージョンがあります",
  update_version_content: "最適な使用環境のため、アプリを最新バージョンに更新してください。",
  close_btn: "閉じる",
  not_video_id: "動画が存在しません",
  favorite_login: "お気に入りのレシピリストを保存するには、ログインまたはサインアップしてください。",
  favorite_section_title: "保存したレシピを確認するのをお忘れなく",
  favorite_section_description: "私のお気に入りのレシピ",
  discover: "発見する",
  my_cooker: "私のキッチン",
  view_recipe: "選んだ材料からレシピを見る",
  my_ingredient: "私の材料",
  add_ingredient: "私の材料を追加する",
  video_section_title: "ビデオで探して感じてみてください",
  video_section_description: "おすすめの料理ビデオ",
  age_10: "10歳未満",
  age_10_to_20: "10〜20歳",
  age_20_to_30: "20〜30歳",
  age_30_to_40: "30〜40歳",
  age_40_to_50: "40〜50歳",
  age_more_50: "50歳以上",
  suggest_section_title: "ヘイ！Cooker が選択をお手伝いします",
  suggest_section_description: "興味のあるトピックは何ですか？",
  weather_title1: "今日のおすすめ",
  weather_title2: "雨の寒い日には何を食べる？",
  tasteSuggestion1: "味覚を満たす",
  tasteSuggestion2: "あなた専用の味わい",
  tasteTitle1: "スパイシー <br />で魅力的",
  tasteDescription1: "#炒める #グリル #雨の日",
  tasteTitle2: "新鮮で <br />軽い",
  tasteTitle3: "酸味があり <br />刺激的",
  tasteTitle4: "香り豊か - <br />甘い",
  tasteTitle5: "混ざり合い <br />魅力的",
  tasteDescription2: "#新鮮 #繊維 #ダイエット",
  tasteDescription3: "#酸っぱい #甘い #刺激的",
  tasteDescription4: "#特別 #種 #魔法",
  tasteDescription5: "#味 #栄養 #感覚",
  suggest_item_title1: "簡単な料理",
  suggest_item_description1: `簡単な朝食と昼食<br/>レシピ`,
  suggest_item_title2: "ダイエット",
  suggest_item_description2: `低炭水化物<br/>本当に美味しい`,
  suggest_item_title3: "年末の食べ物",
  suggest_item_description3: `ホームパーティーの食べ物`,
  suggest_item_title4: "健康食品",
  suggest_item_description4: `健康な体と精神を<br/>作るため`,
  suggest_item_title5: "簡単なスナック",
  suggest_item_description5: `おつまみ`,
  history: "画像解析の履歴",
  community: {
    sub_title: "みんなで料理しよう",
    title: "やあ！クッカーコミュニティ検索",
    trending: "トレンド",
    follow: "フォロー済み",
    video: "ビデオ",
    discover: "発見",
    no_data: "Hey！Cookerコミュニティから新しいアップデートはありません",
    discover_post: "コミュニティでさらに投稿を検索"
  },
  user_suggest_title1: "今日のおすすめ",
  user_suggest_title2: "ランダムレシピの提案",
}


